import { useLocation } from 'react-router-dom';

const useUrlQuery = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export default useUrlQuery;
